import type { ElementRef } from '@angular/core';
import { Directive } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

import { DialogToolbarComponent } from './dialog-toolbar.component';
import { ScrollableDirective } from '../../../../core/overlay/scroll/scrollable.directive';

/**
 * Directive to disabled toolbar radius if it is below the top of the dialog.
 */
@Directive({
  selector: '[rtToolbarRadiusToggle]',
  standalone: true,
})
export class ToolbarRadiusToggleDirective {
  private toolbarElRef: ElementRef;

  constructor(
    private toolbar: DialogToolbarComponent,
    private scrollableDirective: ScrollableDirective,
  ) {
    this.toolbarElRef = toolbar.elementRef;
    this.scrollableDirective.y$.pipe(takeUntilDestroyed()).subscribe(() => {
      const toolbarDistFromTop = this.toolbarElRef.nativeElement.getBoundingClientRect().top;
      this.toolbar.hasRadiusTop.set(toolbarDistFromTop !== 0);
    });
  }
}
